module.exports = __webpack_public_path__ + "static/media/18.522d9393.jpeg";